var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"btn-large pay-btn",attrs:{"disabled":_vm.submitDisabled},on:{"click":_vm.submit}},[_vm._v("Pay with "+_vm._s(_vm.subtype))])])}
var staticRenderFns = []

export { render, staticRenderFns }